<template>
    <div class="step-3">
        <div class="row">
            <div class="col-md-10 offset-md-1">
                <div class="row">
                    <div class="shipping-card-wrap col-md-6" v-for="(item, i) in shippingOptions" :key="i">
                        <div class="shipping-card">
                            <div class="shipping-card-body">
                                <div class="shipping-card-title">{{ item.title }} {{ item.price | currency }}</div>
                                <div class="shipping-card-text">
                                    <div v-if="item.shippingOptionId === 4" v-html="item.address"></div>
                                    <div v-else>
                                        {{ customerDetails.fullName }}<br>
                                        {{ customerDetails.address }}<br>
                                        {{ customerDetails.zip }} {{ customerDetails.city }},
                                        {{ customerDetails.country }}
                                    </div>
                                    <button v-if="item.shippingOptionId !== 4" class="btn btn-light"
                                            @click="$store.dispatch('SET_CHECKOUT_STEP', checkoutStep - 1)">
                                        <span class="material-icon icon-create"/>
                                    </button>
                                </div>
                            </div>
                            <div class="shipping-card-actions">
                                <button class="btn btn-primary btn-shadow text-uppercase" @click="selectShippingOption(i)">
                                    {{ $t('choose') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    .step-3 {
        display: flex;
        min-height: 100%;
        flex-grow: 1;
        flex-direction: column;
        justify-content: center;
    }

    .shipping-card {
        min-height: 280px;
        margin-bottom: 30px;
        padding: 40px 60px;
        background-color: var(--bg-color);

        &:hover {
            box-shadow: 0 5px 15px rgba(#000, .15);
        }

        &-body {
            margin-bottom: 20px;
        }

        &-title {
            min-height: 3rem;
            margin-bottom: 15px;
            color: var(--text-color);
            font-size: 1.5rem;
            line-height: 1;
        }

        &-text {
            position: relative;
            height: 80px;
            overflow: hidden;
            padding-right: 90px;
            color: var(--text-secondary-color);
            font-size: .87rem;

            .btn {
                position: absolute;
                top: 0;
                right: 0;
            }
        }

        &-actions {
            text-align: center;
        }
    }

    .card {
        position: relative;
        cursor: pointer;
        min-height: 280px;
        margin-bottom: 30px;

        h5,
        small {
            padding-right: 90px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }

        small {
            display: block;
        }

        .btn {
            position: absolute;
            right: 3rem;
            bottom: 3rem;
        }
    }

    body.-is-mobile {

        .shipping-card {
            padding-left: 20px;
            padding-right: 20px;
            margin-bottom: 1rem;

            &-wrap:last-child {

                .shipping-card {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>

<script>
  import checkoutStep3 from 'src/mixins/checkoutStep3Component';

  export default {
    mixins: [checkoutStep3],
  };
</script>
